import { useQuery } from "@tanstack/react-query";

import { messagesQueryOptions } from "@/domains/messages/factories/messages-query-options";

export const useMessages = () => {
  return useQuery(messagesQueryOptions.all);
};
